/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
    isSplash: false, // Change this to false if you don't want Splash screen.
  };
  
  //SEO Related settings
  const seo = {
    title: "Revanth Kumar Bondada's Portfolio",
    description:
      "Graduate Student at SJSU with 3 years of experience in AI and Machine Learning application design, specializing in Cloud Data Engineering, Data Warehousing, ETL processes, Business Intelligence, and Reporting.",
    og: {
      title: "Revanth Kumar Bondada Portfolio",
      type: "website",
  
    },
  };
  
  //Home Page
  const greeting = {
    title: "Revanth Kumar Bondada",
    logo_name: "Revanth Kumar Bondada",
    nickname: "Data Scientist",
    subTitle:
      "Graduate Student at SJSU with 3 years of experience in AI and Machine Learning application design, specializing in Cloud Data Engineering, Data Warehousing, ETL processes, Business Intelligence, and Reporting.",
    resumeLink:
      "https://drive.google.com/file/d/1vjapOYTBC4U-tJA-REojRz5ySIeYGL2P/view?usp=sharing",
    portfolio_repository: "https://drive.google.com/file/d/1vjapOYTBC4U-tJA-REojRz5ySIeYGL2P/view?usp=sharing",
    githubProfile: "https://github.com/revanthkumar1999",
  };
  
  const socialMediaLinks = [
    /* Your Social Media Link */
    // github: "https://github.com/ashutosh1919",
    // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
    // gmail: "ashutoshhathidara98@gmail.com",
    // gitlab: "https://gitlab.com/ashutoshhathidara98",
    // facebook: "https://www.facebook.com/laymanbrother.19/",
    // twitter: "https://twitter.com/ashutosh_1919",
    // instagram: "https://www.instagram.com/layman_brother/"
  
    {
      name: "Github",
      link: "https://github.com/revanthkumar1999",
      fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
      backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
    },
    {
      name: "LinkedIn",
      link: "https://www.linkedin.com/in/revanthkumarbondada/",
      fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
      backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
    }, 
    /*
    {
      name: "YouTube",
      link: "https://youtube.com/c/DevSense19",
      fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
      backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
    }, */
    {
      name: "Gmail",
      link: "mailto:reventhkumarbondada@gmail.com",
      fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
      backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
    },
    {
      name: "Outlook",
      link: "mailto:revanthkumar.bondada@sjsu.edu",
      fontAwesomeIcon: "fas fa-envelope", // Reference https://fontawesome.com/icons/google?style=brands
      backgroundColor: "#4079A3", // Reference https://simpleicons.org/?q=gmail
    },
    /*
    {
      name: "X-Twitter",
      link: "https://twitter.com/ashutosh_1919",
      fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
      backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
    },
    {
      name: "Facebook",
      link: "https://www.facebook.com/laymanbrother.19/",
      fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
      backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
    },
    {
      name: "Instagram",
      link: "https://www.instagram.com/layman_brother/",
      fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
      backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
    }, */
  ];
  
  const skills = {
    data: [
     /* {
        title: "Data Science, Machine Learing & AI",
        fileName: "DataScienceImg",
        skills: [
          "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
          "⚡ Experience of working with Computer Vision and NLP projects",
          "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
          "⚡ Working and Exploring more on deep learning models on cloud"
        ],
        softwareSkills: [
          {
            skillName: "Tensorflow",
            fontAwesomeClassname: "logos-tensorflow",
            style: {
              backgroundColor: "transparent",
            },
          },
          {
            skillName: "Keras",
            fontAwesomeClassname: "simple-icons:keras",
            style: {
              backgroundColor: "white",
              color: "#D00000",
            },
          },
          {
            skillName: "PyTorch",
            fontAwesomeClassname: "logos-pytorch",
            style: {
              backgroundColor: "transparent",
            },
          },
          {
            skillName: "Python",
            fontAwesomeClassname: "ion-logo-python",
            style: {
              backgroundColor: "transparent",
              color: "#3776AB",
            },
          },
          {
            skillName: "Deeplearning",
            imageSrc: "deeplearning_ai_logo.png",
          },
        ],
      }, */
  
      {
        title: "Data Analytics & Machine Learning",
        fileName: "DataScienceImg",
        skills: [
          "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
          "⚡ Experience of working with Computer Vision, Pytorch and Tensorflow projects",
          "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
          "⚡ Enhanced my expertise in machine learning models, achieving significantly higher accuracy rates"
        ],
        softwareSkills: [
          {
            skillName: "Tensorflow",
            fontAwesomeClassname: "logos-tensorflow",
            style: {
              backgroundColor: "transparent",
            },
          },
         /* {
            skillName: "Keras",
            fontAwesomeClassname: "simple-icons:keras",
            style: {
              backgroundColor: "white",
              color: "#D00000",
            },
          }, */
          {
            skillName: "PyTorch",
            fontAwesomeClassname: "logos-pytorch-icon",
            style: {
              backgroundColor: "transparent",
            },
          },
          {
            skillName: "Python",
            fontAwesomeClassname: "ion-logo-python",
            style: {
              backgroundColor: "transparent",
              color: "#3776AB",
            },
          },
          {
            skillName: "Pandas",
            fontAwesomeClassname: "devicon:pandas",
            style: {
              backgroundColor: "transparent",
              color: "#3776AB",
            },
          },
          {
            skillName: "Numpy",
            fontAwesomeClassname: "logos:numpy",
            style: {
              backgroundColor: "transparent",
              color: "#3776AB",
            },
          },
          {
            skillName: "Scipy",
            fontAwesomeClassname: "simple-icons:scipy",
            style: {
              backgroundColor: "transparent",
              color: "#3776AB",
            },
          },
          {
            skillName: "Kera",
            fontAwesomeClassname: "devicon:keras",
            style: {
              backgroundColor: "transparent",
              color: "#3776AB",
            },
          },

          {
            skillName: "Machine Learning",
            fontAwesomeClassname: "healthicons:m",
            style: {
              backgroundColor: "transparent",
              color: "#39ac39",
            },
          },
          {
            skillName: "AI",
            fontAwesomeClassname: "eos-icons:ai",
            style: {
              backgroundColor: "transparent",
              color: "#0066ff",
            },
          },

          {
            skillName: "NLP",
            fontAwesomeClassname: "twemoji:letter-n",
            style: {
              backgroundColor: "transparent",
              color: "#3776AB",
            },
          },

          {
            skillName: "LLMs",
            fontAwesomeClassname: "lucide:network",
            style: {
              backgroundColor: "transparent",
              color: "#65B08D",
            },
          },
          {
            skillName: "Flask",
            fontAwesomeClassname: "devicon:flask",
            style: {
              backgroundColor: "transparent",
              color: "#3776AB",
            },
          },
          {
            skillName: "Deeplearning",
            imageSrc: "deeplearning_ai_logo.png",
          },
  
        ],
      },
      {
        title: "Cloud, ETL & Datawarehousing",
        fileName: "CloudInfraImg",
        skills: [
          "⚡ Experience working on multiple cloud and data warehouse platforms",
          "⚡ Developed many ETL and ELT pipelines using various platforms",
          "⚡ Working and Exploring more on deep learning models on cloud to use on mobile devices",
          "⚡ Setting up streaming jobs from DB to Server or vice-versa on Azure, AWS and many other Tools",
        ],
        softwareSkills: [
          {
            skillName: "GCP",
            fontAwesomeClassname: "simple-icons:googlecloud",
            style: {
              color: "#4285F4",
            },
          },
          {
            skillName: "AWS",
            fontAwesomeClassname: "logos:aws",
            style: {
              color: "#FF9900",
            },
          },
          {
            skillName: "Azure",
            fontAwesomeClassname: "simple-icons:microsoftazure",
            style: {
              color: "#0089D6",
            },
          },
          {
            skillName: "Snowflake",
            fontAwesomeClassname: "fxemoji:snowflake",
            style: {
              color: "#FFCA28",
            },
          },
          {
            skillName: "ApacheAirflow",
            fontAwesomeClassname: "logos:airflow-icon",
            style: {
              color: "#336791",
            },
          },
          {
            skillName: "MongoDB",
            fontAwesomeClassname: "simple-icons:mongodb",
            style: {
              color: "#47A248",
            },
          },
          {
            skillName: "Hadoop",
            fontAwesomeClassname: "logos:hadoop",
            style: {
              backgroundColor: "transparent",
              color: "#3776AB",
            },
          },
          {
            skillName: "FiveTran",
            fontAwesomeClassname: "healthicons:f-negative",
            style: {
              color: "#0594F1",
            },
          },
          {
            skillName: "Jira",
            fontAwesomeClassname: "logos:jira",
            style: {
              color: "#1488C6",
            },
          },
          {
            skillName: "Docker",
            fontAwesomeClassname: "simple-icons:docker",
            style: {
              color: "#1488C6",
            },
          },
          {
            skillName: "Kubernetes",
            fontAwesomeClassname: "simple-icons:kubernetes",
            style: {
              color: "#326CE5",
            },
          },
        ],
      },
      {
        title: "Full Stack Development",
        fileName: "FullStackImg",
        skills: [
          "⚡ Building responsive website front end using React-Redux",
          "⚡ Developing mobile applications using Flutter, React Native and solo android apps using Kotlin",
          "⚡ Creating application backend in Node, Express & Flask",
        ],
        softwareSkills: [
          {
            skillName: "HTML5",
            fontAwesomeClassname: "simple-icons:html5",
            style: {
              color: "#E34F26",
            },
          },
          {
            skillName: "CSS3",
            fontAwesomeClassname: "fa-css3",
            style: {
              color: "#1572B6",
            },
          },
          {
            skillName: "Sass",
            fontAwesomeClassname: "simple-icons:sass",
            style: {
              color: "#CC6699",
            },
          },
          {
            skillName: "JavaScript",
            fontAwesomeClassname: "simple-icons:javascript",
            style: {
              backgroundColor: "#000000",
              color: "#F7DF1E",
            },
          },
          {
            skillName: "ReactJS",
            fontAwesomeClassname: "simple-icons:react",
            style: {
              color: "#61DAFB",
            },
          },
          {
            skillName: "NodeJS",
            fontAwesomeClassname: "teenyicons:nodejs-outline",
            style: {
              color: "#339933",
            },
          },
          {
            skillName: "NPM",
            fontAwesomeClassname: "simple-icons:npm",
            style: {
              color: "#CB3837",
            },
          },
          {
            skillName: "Yarn",
            fontAwesomeClassname: "simple-icons:yarn",
            style: {
              color: "#2C8EBB",
            },
          },
          {
            skillName: "Gatsby",
            fontAwesomeClassname: "simple-icons:gatsby",
            style: {
              color: "#663399",
            },
          },
          {
            skillName: "AWS",
            fontAwesomeClassname: "simple-icons:aws",
            style: {
              color: "#FF9900",
            },
          },
        ],
      },
      
      {
        title: "Business Intelligence & Reporting",
        fileName: "DesignImg",
        skills: [
          "⚡ Expertise in working with Power BI, Tableau, and QuickSight",
          "⚡ Experience in creating BI reports and dashboards, and publishing them to the cloud",
          "⚡ Worked on data modeling, understanding relationships, measures, DAX for advanced calculations",
        ],
        softwareSkills: [
          {
            skillName: "Power BI",
            fontAwesomeClassname: "simple-icons:powerbi",
            style: {
              color: "#f1c232",
            },
          },
          {
            skillName: "Tableau",
            fontAwesomeClassname: "simple-icons:tableau",
            style: {
              color: "#F24E1E",
            },
          },
          {
            skillName: "Quicksight",
            fontAwesomeClassname: "logos:aws-quicksight",
            style: {
              color: "#4285F4",
            },
          },
  
        ],
      },
    ],
  };
  
  // Education Page
  const competitiveSites = {
    competitiveSites: [
     /* {
        siteName: "LeetCode",
        iconifyClassname: "simple-icons:leetcode",
        style: {
          color: "#F79F1B",
        },
        profileLink: "https://leetcode.com/layman_brother/",
      },
      {
        siteName: "HackerRank",
        iconifyClassname: "simple-icons:hackerrank",
        style: {
          color: "#2EC866",
        },
        profileLink: "https://www.hackerrank.com/layman_brother",
      },
      {
        siteName: "Codechef",
        iconifyClassname: "simple-icons:codechef",
        style: {
          color: "#5B4638",
        },
        profileLink: "https://www.codechef.com/users/ashutosh_1919",
      },
      {
        siteName: "Codeforces",
        iconifyClassname: "simple-icons:codeforces",
        style: {
          color: "#1F8ACB",
        },
        profileLink: "http://codeforces.com/profile/layman_brother",
      },
      {
        siteName: "Hackerearth",
        iconifyClassname: "simple-icons:hackerearth",
        style: {
          color: "#323754",
        },
        profileLink: "https://www.hackerearth.com/@ashutosh391",
      },
      {
        siteName: "Kaggle",
        iconifyClassname: "simple-icons:kaggle",
        style: {
          color: "#20BEFF",
        },
        profileLink: "https://www.kaggle.com/laymanbrother",
      }, */
    ], 
  };
  
  const degrees = {
    degrees: [
      
      {
        title: "San José State University",
        subtitle: "M.S. in Data Analytics",
        logo_path: "sjsu_logo1.png",
        alt_name: "San José State University",
        duration: "2023 - 2025",
        descriptions: [
          "⚡ I have taken varity of courses related to Data Science & Machine Learning which correspond to Explainable NLP, LLM's, Statistics, Insights etc.",
          "⚡ Apart from this, I have also done research assistantship. As part of it, I have worked on creating new algorithms in Graph ML and Network Science.",
          "⚡ During my time at university, Also I explored and learned about many ETL & ELT techniques using cloud platforms AWS, GCP & Azure.",
        ],
        website_link: "https://www.sjsu.edu/",
      },
      {
        title: "MLR Institute of Technology",
        subtitle: "B.Tech. in Computer Science & Engineering",
        logo_path: "mlrit.png",
        alt_name: "MLRIT Hyderabad",
        duration: "2016 - 2020",
        descriptions: [
          "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, AI etc.",
          "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
          "⚡ I was selected for Merit cum Means Scholarship which is given to top 10% of students in college. I have received award from respected director for consistently best performance in academics.",
        ],
        website_link: "https://mlrit.ac.in/",
      },
    ],
  };
  
  const certifications = {
    certifications: [
   /*   {
        title: "Machine Learning",
        subtitle: "- Andrew Ng",
        logo_path: "stanford_logo.png",
        certificate_link:
          "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
        alt_name: "Stanford University",
        color_code: "#8C151599",
      },
      {
        title: "Deep Learning",
        subtitle: "- Andrew Ng",
        logo_path: "deeplearning_ai_logo.png",
        certificate_link:
          "https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G",
        alt_name: "deeplearning.ai",
        color_code: "#00000099",
      },
      {
        title: "ML on GCP",
        subtitle: "- GCP Training",
        logo_path: "google_logo.png",
        certificate_link:
          "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
        alt_name: "Google",
        color_code: "#0C9D5899",
      },
      {
        title: "Data Science",
        subtitle: "- Alex Aklson",
        logo_path: "ibm_logo.png",
        certificate_link:
          "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
        alt_name: "IBM",
        color_code: "#1F70C199",
      },
      {
        title: "Big Data",
        subtitle: "- Kim Akers",
        logo_path: "microsoft_logo.png",
        certificate_link:
          "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
        alt_name: "Microsoft",
        color_code: "#D83B0199",
      },
      {
        title: "Advanced Data Science",
        subtitle: "- Romeo Kienzler",
        logo_path: "ibm_logo.png",
        certificate_link:
          "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
        alt_name: "IBM",
        color_code: "#1F70C199",
      },
      {
        title: "Advanced ML on GCP",
        subtitle: "- GCP Training",
        logo_path: "google_logo.png",
        certificate_link:
          "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
        alt_name: "Google",
        color_code: "#0C9D5899",
      },
      {
        title: "DL on Tensorflow",
        subtitle: "- Laurence Moroney",
        logo_path: "deeplearning_ai_logo.png",
        certificate_link:
          "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
        alt_name: "deeplearning.ai",
        color_code: "#00000099",
      },
      {
        title: "Fullstack Development",
        subtitle: "- Jogesh Muppala",
        logo_path: "coursera_logo.png",
        certificate_link:
          "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
        alt_name: "Coursera",
        color_code: "#2A73CC",
      },
      {
        title: "Kuberenetes on GCP",
        subtitle: "- Qwiklabs",
        logo_path: "gcp_logo.png",
        certificate_link:
          "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
        alt_name: "GCP",
        color_code: "#4285F499",
      },
      {
        title: "Cryptography",
        subtitle: "- Saurabh Mukhopadhyay",
        logo_path: "nptel_logo.png",
        certificate_link:
          "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
        alt_name: "NPTEL",
        color_code: "#FFBB0099",
      },
      {
        title: "Cloud Architecture",
        subtitle: "- Qwiklabs",
        logo_path: "gcp_logo.png",
        certificate_link:
          "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
        alt_name: "GCP",
        color_code: "#4285F499",
      }, */
    ],
  };
  
  // Experience Page
  const experience = {
    title: "Experience",
    subtitle: "Work and Volunteership",
    description:
      "I'm specialized in data integration, optimization, and analytics using technologies like AWS, Azure, GCP, Tensorflow, PyTorch, LLMs, NLP, Snowflake, Power BI, Redshift, Tableau, SQL, and Python, enhancing decision-making and productivity.",
    header_image_path: "experience.svg",
    sections: [
      {
        title: "Work",
        work: true,
        experiences: [
          {
            title: "Data Scientist",
            company: "Caterpiller Inc",
            company_url: "https://www.caterpillar.com/",
            logo_path: "cat.png",
            duration: "Aug 2022 - Jul 2023",
            location: "North Carolina, United States(Remote)",
            description:
              "I collaborated with teams to integrate data from various sources into Power BI dashboards, which provided actionable insights and enhanced data-driven decision-making in two departments. My work included orchestrating data extraction from multiple sources like APIs, DB2, CRM systems, SQL databases, and RPA. I utilized AWS Lambda to ingest this data into Snowflake, applying data optimization techniques akin to those used in Apache Iceberg for more efficient processing. By leveraging Snowflake's capabilities along with SQL, I was able to curate and model data, and schedule tasks, which streamlined data workflows and improved efficiency by 16.8%. Additionally, I implemented automation using Python, RPA, Power Apps, and VBA. This not only improved data flow but also allowed me to conduct experiments with Large Language Models (LLMs) and Natural Language Processing (NLP). Enhancing data presentation in Power BI, these efforts boosted business productivity from 86.5% to 94.8%.",
            color: "#0879bf",
          },
          {
            title: "Data Analyst",
            company: "Polaris Inc",
            company_url: "https://www.polaris.com/en-us/",
            logo_path: "polaris.png",
            duration: "Apr 2021 - Aug 2022",
            location: "Plymouth, Massachusetts, United States(Remote)",
            description:
              "The process involved extracting, transforming, and loading vehicle data from a variety of sources into Redshift using AWS Lambda and Glue. This approach allowed for scheduled transformations and the creation of data models tailored for analytics purposes. The processed data was then transferred into S3 in parquet format, which significantly enhanced reporting capabilities when using Tableau. Additionally, the use of project management tools like Workfront and Jira facilitated better organization of the projects. This optimization of data processes, coupled with effective teamwork, led to a 10% increase in productivity, thereby providing more informed insights in the automobile industry.",
            color: "#9b1578",
          },
          {
            title: "Software Engineer",
            company: "Yash Technologies Pvt. Ltd.",
            company_url: "https://www.yash.com/",
            logo_path: "yash.png",
            duration: "Sep 2020 - Apr 2021",
            location: "Hyderabad, Telangana",
            description:
              "I created a Java-based Product Inventory System that uses JavaScript and leverages a combination of MySQL, Hive, Azure Data Factory, and Azure Data Lake for robust data storage. This integration and system design resulted in a 12.7% improvement in effectiveness. Additionally, I designed data models for products, suppliers, and transactions and developed interactive Tableau dashboards. These dashboards provide insightful visualizations of inventory trends, which have led to an 18% reduction in excess inventory.",
            color: "#fc1f20",
          },
        ],
      },/*
      {
        title: "Internships",
        experiences: [
          {
            title: "Machine Learning Intern",
            company: "TikTok Inc.",
            company_url: "https://www.tiktok.com/en/",
            logo_path: "tiktok_logo.png",
            duration: "May 2022 - Aug 2022",
            location: "San Francisco, USA",
            description:
              "Building new features on the backend recommendation system, specifically ranking algorithms for Ads that touch hundreds of millions of people around the world. Improving online and offline content ranking algorithms by performing hard sample data replays for training steps.",
            color: "#000000",
          },
          {
            title: "Data Science Research Intern",
            company: "Delhivery Pvt. Ltd.",
            company_url: "https://www.delhivery.com/",
            logo_path: "delhivery_logo.png",
            duration: "May 2019 - Sept 2019",
            location: "Gurgaon, Haryana",
            description:
              "I have worked on project of predicting freight rates based on previous data. There were two objectives: (1) To build a forecasting engine to predict daily freight rates. (2) To embed feature in the model which can explain the seasonal major changes in freight rate based on regions and locations. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2 with the use of Kafka stream jobs, ElasticSearch and PostgreSQL.",
            color: "#ee3c26",
          },
          {
            title: "Data Science Intern",
            company: "Intel Indexer LLC",
            company_url:
              "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
            logo_path: "intel_logo.jpg",
            duration: "Nov 2018 - Dec 2018",
            location: "Work From Home",
            description:
              "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
            color: "#0071C5",
          },
        ],
      },*/
      {
        title: "Volunteerships",
        experiences: [
          {
            title: "ETL Trainer",
            company: "Yash Technologies Pvt Ltd",
            company_url: "https://www.yash.com/",
            logo_path: "yash.png",
            duration: "May 2022 - Jun 2023",
            location: "Hyderabad, Telangana",
            description:
              "I provided hands-on training for new employees in ETL, covering Azure, AWS, and Snowflake. The sessions focused on data extraction, orchestration, and modeling, equipping them with essential skills for efficient data management and processing in cloud environments.",
            color: "#4285F4",
          },
        ],
      },
    ],
  };
  
  // Projects Page
  const projectsHeader = {
    title: "Projects",
    description:
      "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to business applications using cloud infrastructure.",
    avatar_image_path: "projects_image.svg",
  };
  
  const publicationsHeader = {
    
  };
  
  const publications = {
    data: [
      
    ],
  };
  
  // Contact Page
  const contactPageData = {
    contactSection: {
      title: "Contact Me",
      profile_image_path: "Profile-1-ss-art.png",
      description:
        "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React, Android, Cloud and Opensource Development.",
    },
    blogSection: {
    /*  title: "Blogs",
      subtitle:
        "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
      link: "https://reventhkumarbondada.hashnode.dev/",
      avatar_image_path: "blogs_image.svg", */
    },
    addressSection: {
    /*  title: "Address",
      subtitle:
        "Ambavadi vas, Kanodar, T.A.-Palanpur, Dist.-Banaskantha, Gujarat - 385520",
      locality: "Kanodar",
      country: "IN",
      region: "Gujarat",
      postalCode: "385520",
      streetAddress: "Ambavadi vas",
      avatar_image_path: "address_image.svg",
      location_map_link: "https://goo.gl/maps/MpMqtRZytFchMkZ76", */
    },
    phoneSection: {
      title: "",
      subtitle: "",
    },
  };
  
  export {
    settings,
    seo,
    greeting,
    socialMediaLinks,
    skills,
    competitiveSites,
    degrees,
    certifications,
    experience,
    projectsHeader,
    publicationsHeader,
    publications,
    contactPageData,
  };
  